import React from "react";
import { CookEInput } from "../components/CommonComponents";

export default function DishOption({
  title,
  name,
  value,
  handleChange,
  placeholder,
  isDishePages,
  beta,
}) {
  return (
    <div className="w-full md:my-2 my-1.5  md:space-y-0 space-y-1 md:flex-row flex-col md:justify-center md:items-center">
      {/* Title Section */}
      <div>
        <p className="pb-2 font-inter text-black dark:text-white flex ">
          {title}
        </p>

        {/* Optional Beta Message */}
        {/* {beta && (
                    <label
                        htmlFor=""
                        className="text-sm text-transparent ml-2 hidden sm:block"
                    >
                        &#8226; Feature is in Early Beta
                    </label>
                )} */}
      </div>

      {/* Input Field Container */}
      <div className="w-full">
        <CookEInput
          name={name}
          value={value}
          type="text"
          placeholder={placeholder}
          onChange={handleChange}
        />
        {/* {beta && (
                    <label htmlFor="" className="text-sm text-orange-400 ml-2">
                        &#8226; Feature is in Early Beta
                    </label>
                )} */}
      </div>
    </div>
  );
}
